// API配置文件
// 本地开发：web/.env.development  =>  http://127.0.0.1:9090（npm run serve）
// 生产部署：web/.env.production   =>  https://admin.lingmouyuntu.xyz（npm run build）
export const BASE_URL = process.env.VUE_APP_BASE_URL || 'http://127.0.0.1:9090';
export const TIMEOUT = 10000; // 请求超时时间：10秒 